var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',_vm._b({attrs:{"color":_vm.color,"max-width":_vm.maxWidth},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('div',_vm._g(_vm._b({staticClass:"container_activator"},'div',attrs,false),on),[_vm._t("default")],2)]}}],null,true)},"v-tooltip",_vm._d({},[_vm.position,true])),[_vm._t("message")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }